import styled from 'styled-components';
import { SIZE, LAYERS } from '../../common/sizes';
import { DEFAULT_FONT_FAMILY, BUTTON_ACTION_HEIGHT } from 'common/constants';
import { Label } from 'common/baseComponents';

export const ListEditorMainContainer = styled.ul`
    display: flex;
    flex-flow: column;
    margin: 0;
    padding: 0;
    list-style: none;
`

export const ListEditorItem = styled.li`
    display:flex;
    align-items:center;
    margin: ${SIZE.QUART}px 0;
    
`

export const ListItemContent = styled.div`
    display:flex;
    padding: ${SIZE.ONE}px ${SIZE.TWO}px;
    border-radius: 5px;
    box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.1);
    border: solid 1px rgba(130, 130, 130, 0.5);
    flex: 1;
    background-color: #ffffff;
`

export const ActionContainer = styled.div`
    display:flex;
    margin:0 ${SIZE.ONE}px;
    &:hover {
        cursor: pointer;
        transform: scale(1.2);
    }
    transition: all 0.300s;
`;